<template>
  <div class="w-6/12 mx-auto">
    <div class="flex flex-col">
      <div class="mb-6">
        <label class="font-semibold text-md text-grey-700">
          {{ $t('frontend_groovemail_leads_import_multiple_leads_question_records_source') }}
        </label>
        <text-area
          class="mt-2"
          variant="base"
          v-model="localModel.recordsSource"
          :placeholder="$t('frontend_groovemail_leads_import_multiple_leads_questions_placeholder')"
          rows="3"
        />
        <p
          v-if="stepSaved && (!localModel.recordsSource || !localModel.recordsSource.trim())"
          class="text-sm text-danger"
        >
          {{ $t('frontend_groovemail_leads_import_multiple_leads_question_records_source_attribute') }}
        </p>
      </div>
      <div class="mb-6">
        <label class="font-semibold text-md text-grey-700">
          {{ $t('frontend_groovemail_leads_import_multiple_leads_question_commercial_platform') }}
        </label>
        <text-area
          class="mt-2"
          variant="base"
          v-model="localModel.commercialPlatform"
          :placeholder="$t('frontend_groovemail_leads_import_multiple_leads_questions_placeholder')"
          rows="3"
        />
        <p
          v-if="stepSaved && (!localModel.commercialPlatform || !localModel.commercialPlatform.trim())"
          class="text-sm text-danger"
        >
          {{ $t('frontend_groovemail_leads_import_multiple_leads_question_commercial_platform_attribute') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'step1',
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      stepSaved: false,
      localModel: this.model,
    };
  },

  methods: {
    validate() {
      this.stepSaved = true;
      let isValid = false;
      if (
        this.localModel.recordsSource &&
        this.localModel.recordsSource.trim() &&
        this.localModel.commercialPlatform &&
        this.localModel.commercialPlatform.trim()
      ) {
        isValid = true;
      }
      this.$emit('on-validate', isValid);
      return isValid;
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>